module.exports = __webpack_public_path__ + "img/architectureImg1.e50471d9.jpeg";